export interface TestimonialSlot {
  theme: string
  brief: string
  attribution: string
}

export const testimonialSlotsSerie1: TestimonialSlot[] = [
  {
    theme: 'Progrès visible, parcours mené au bout',
    brief:
      'Un coach dont le client est arrivé à la séance 10 et a su dire ce qu’il avait obtenu.',
    attribution: 'Prénom + initiale · Coach professionnelle, certifiée [RNCP / ICF]',
  },
  {
    theme: 'Crise résolue',
    brief:
      'La quatrième séance qui ne s’est pas terminée en abandon, grâce au bilan de phase ou au Point d’Ancrage.',
    attribution: 'Prénom + initiale · Coach professionnel, certifié [RNCP / ICF]',
  },
  {
    theme: 'Changement de statut',
    brief:
      'Se sentir légitime, présenter un parcours sans avoir l’impression de vendre.',
    attribution: 'Prénom + initiale · Coach professionnelle, certifiée [RNCP / ICF]',
  },
]

export const testimonialSlotsSerie2: TestimonialSlot[] = [
  {
    theme: 'La Séance Zéro',
    brief:
      'Une citation qui nomme le déroulé de 75 minutes et le contrat d’accompagnement.',
    attribution: 'Prénom + initiale · Coach, 2e année',
  },
  {
    theme: 'Le Point d’Ancrage et le bilan de la séance 3',
    brief:
      'Une citation qui nomme le passage de la phase Fondations à la phase Élan.',
    attribution: 'Prénom + initiale · Coach certifiée RNCP',
  },
  {
    theme: 'Le Carnet du coaché et la fiche Signaux d’orientation',
    brief:
      'Une citation qui nomme les supports utilisés en séance avec le client.',
    attribution: 'Prénom + initiale · Coach, 2e année',
  },
]
